<template>
	<div class="MapPage">
		<MapHeader />

		<MglMap
			class="Map"
			@load="onMapLoaded"
			:accessToken="accessToken"
			:mapStyle.sync="mapStyle"
			:attributionControl="false"
			:center="center"
			:zoom="zoom"
		>
			<div class="sidebar-right">
				<SearchSection @search="search($event)" />

				<div class="layout-switcher" v-if="showDisplayOptions">
					<h1 class="thermo">Weergave</h1>
					<div style="display: flex; justify-content: space-between; margin-bottom: 0.5em;">
						<span @click="closeListView()">Kaart</span>
						<ToggleField
							type="radio"
							name="layout"
							:key="'showSearchPopupFalse'"
							:checked="showSearchPopup === false"
							@change="closeListView()"
						/>
					</div>
					<div style="display: flex; justify-content: space-between; margin-bottom: 0.5em;">
						<span @click="openListView()">Lijst</span>
						<ToggleField
							type="radio"
							name="layout"
							:key="'showSearchPopupTrue'"
							:checked="showSearchPopup === true"
							@change="openListView()"
						/>
					</div>
				</div>

				<SupportFilter
					v-if="mapType === 'support'"
					:filter="lastFilterType"
					@filterChange="getMapDataForSupportMarker($event)"
				/>
				<PlanningFilter
					v-if="mapType === 'planning'"
					:filter="lastFilterType"
					@filterChange="getMapDataForDefaultMarker($event)"
				/>
				<AppointmentsFilter
					v-if="mapType === 'appointments'"
					:filter="lastFilterType"
					@filterChange="getMapDataForAppointmentMarker($event)"
				/>
				<ExecutionFilter
					v-if="mapType === 'uitvoering'"
					:filter="lastFilterType"
					@filterChange="getMapDataForProjectMarker($event)"
				/>
				<MarketingFilter
					v-if="mapType === 'marketing'"
					:filter="lastFilterType"
					@filterChange="getMapDataForDefaultMarker($event)"
				/>

				<ExecutionAppointmentFilter
					v-if="mapType === 'execution-appointments'"
					:filter="lastFilterType"
					@filterChange="getMapDataForProjectMarker($event)"
				/>
				<QualityFilter
					v-if="mapType === 'quality'"
					:filter="lastFilterType"
					@filterChange="getMapDataForDefaultMarker($event)"
				/>

				<Button @click="openAddRelationModal" class="add-relation-button">
					<template v-slot:icon>
						<UserIcon size="1.25x"/>
					</template>
					RELATIE TOEVOEGEN
				</Button>
			</div>

			<MapCard class="search-card" v-if="showSearchPopup">
				<div class="header">
					<h1 class="search-header">Resultaten</h1>
					<button @click="closeListView()">
						<XIcon></XIcon>
					</button>
				</div>
				<div class="content">
					<div v-if="((mapType === 'uitvoering' ||  mapType === 'execution-appointments') && project_markers.length === 0) || ( mapType !== 'uitvoering' && markers.length === 0)">
						Geen resultaten
					</div>
					<SearchRow
						:data="(mapType === 'uitvoering' ||  mapType === 'execution-appointments' ? result.company : result)"
						:popupData="result"
						class="search-item"
						v-for="result in (mapType === 'uitvoering' ||  mapType === 'execution-appointments' ? project_markers : markers)"
						:key="result.id"
						@openPopup="openListViewPopup($event)"
					/>
				</div>
			</MapCard>
			<div class="mapboxgl-popup-content list-view-popup" v-if="showListViewPopup">
				<button
					class="mapboxgl-popup-close-button" type="button" @click="showListViewPopup = false;
        selectedListItem = {}"
				>×
				</button>
				<MarkerPopup v-if="mapType === 'appointments' || mapType === 'planning'" :data="selectedListItem"/>
				<ProjectMarkerPopup v-if="mapType === 'execution-appointments'" :data="selectedListItem" :filter="lastFilterType"/>
			</div>

			<div class="add-relation-backdrop" v-if="showAddRelationModal">
				<MapCard class="add-relation-modal">
					<div class="forms-container">
						<div class="header">
							<h1 class="search-header">Formulieren</h1>
						</div>
						<div class="content">
							<div class="forms-item">
								<span @click="switchForm('antwoordkaart')">Antwoordkaart</span>
								<ToggleField
									type="radio"
									name="formType"
									:checked="formType === 'antwoordkaart'"
									@change="switchForm('antwoordkaart')"
								/>
							</div>
							<div class="forms-item">
								<span @click="switchForm('telefoon')">Telefoon</span>
								<ToggleField
									type="radio"
									name="formType"
									:checked="formType === 'telefoon'"
									@change="switchForm('telefoon')"
								/>
							</div>
							<div class="forms-item">
								<span @click="switchForm('e-mail')">E-mail</span>
								<ToggleField
									type="radio"
									name="formType"
									:checked="formType === 'e-mail'"
									@change="switchForm('e-mail')"
								/>
							</div>
							<div class="forms-item">
								<span @click="switchForm('kmk')">KMK</span>
								<ToggleField
									type="radio"
									name="formType"
									:checked="formType === 'kmk'"
									@change="switchForm('kmk')"
								/>
							</div>
							<div class="forms-item">
								<span @click="switchForm('pure energie')">Pure Energie</span>
								<ToggleField
									type="radio"
									name="formType"
									:checked="formType === 'pure energie'"
									@change="switchForm('pure energie')"
								/>
							</div>
						</div>
					</div>
					<div class="card-container">
						<div class="header">
							<h1 class="search-header">{{ formType }}</h1>
							<button @click="closeAddRelationModal">
								<XIcon></XIcon>
							</button>
						</div>
						<div class="content">
							<ReplyCardForm v-if="formType === 'antwoordkaart'"></ReplyCardForm>
							<PhoneForm
								v-if="formType === 'telefoon'"
								:formType="formType"
								@saved="closeAddRelationModal"
							></PhoneForm>
							<EmailForm
								v-if="formType === 'e-mail'"
								:formType="formType"
								@saved="closeAddRelationModal"
							></EmailForm>
							<KmkForm
								v-if="formType === 'kmk'"
								:formType="formType"
								@saved="closeAddRelationModal"
							></KmkForm>
							<PureEnergieForm
								v-if="formType === 'pure energie'"
								:formType="formType"
								@saved="closeAddRelationModal"
							></PureEnergieForm>
						</div>
					</div>
				</MapCard>
			</div>

			<MglNavigationControl position="top-left"/>

			<MglMarker v-for="tracking in trackings" :key="tracking.id" :coordinates="tracking.coordinates">
				<span slot="marker">
					<img src="/map/dist/skin/icon-car.svg" style="width: 24px;"/>
				</span>
			</MglMarker>

			<MglMarker
				v-if="mapType !== 'uitvoering' && mapType !== 'execution-appointments' && mapType !== 'support'"
				v-for="marker in markers"
				anchor="bottom"
				:key="`${marker.id}_${marker.color}`"
				:coordinates="marker.coordinates"
				:color="marker.color"
				@click="openPopup = marker.id"
			>
				<MglPopup
					v-if="openPopup === marker.id"
					:offset="40"
					@close="closePopup(marker.id)"
					anchor="bottom"
					:filterPeriod="40"
					@open="onPopupOpen"
				>
					<MarkerPopup :data="marker" :filter="lastFilterType"/>
				</MglPopup>
			</MglMarker>
			<MglMarker
				v-if="mapType === 'uitvoering' || mapType === 'execution-appointments'"
				v-for="marker in project_markers"
				anchor="bottom"
				:key="`${marker.id}_${marker.color}`"
				:coordinates="marker.coordinates"
				@click="openPopup = marker.id"
			>
				<TSMapMarker slot="marker" :color="marker.color" :detail-text="formatSqMeter(marker.mainProjectLineAmount)"></TSMapMarker>
				<template v-slot:default>
					<MglPopup
						v-if="openPopup === marker.id"
						:offset="40"
						anchor="bottom"
						:filterPeriod="40"
						@close="closePopup(marker.id)"
						@open="onPopupOpen"
					>
						<ProjectMarkerPopup :data="marker" :project-type="appointmentType" :filter="lastFilterType"/>
					</MglPopup>
				</template>
			</MglMarker>
			<MglMarker
				v-if="mapType === 'support'"
				v-for="marker in support_ticket_markers"
				anchor="bottom"
				:key="`${marker.id}_${marker.color}`"
				:coordinates="marker.project.company.coordinates"
				@click="onClickSupport(marker)"
			>
				<TSMapMarker slot="marker" :color="marker.color" :detail-text="formatSqMeter(marker.mainProjectLineAmount)"></TSMapMarker>
			</MglMarker>
		</MglMap>
	</div>
</template>

<script>
import Button from "@/components/Button";
import CardStack from "@/components/CardStack";
import DropdownButton from "@/components/DropdownButton";
import EmailForm from "@/components/EmailForm";
import KmkForm from "@/components/KmkForm";
import AppointmentsFilter from "@/components/map/AppointmentsFilter.vue";
import ExecutionAppointmentFilter from "@/components/map/ExecutionAppointmentFilter.vue";
import ExecutionFilter from "@/components/map/ExecutionFilter.vue";
import MapHeader from "@/components/map/MapHeader.vue";
import MarketingFilter from "@/components/map/MarketingFilter.vue";
import PlanningFilter from "@/components/map/PlanningFilter.vue";
import QualityFilter from "@/components/map/QualityFilter.vue";
import SearchSection from "@/components/map/SearchSection.vue";
import SupportFilter from "@/components/map/SupportFilter.vue";
import PureEnergieForm from "@/components/PureEnergieForm";
import LoadingIndicator from "@/components/LoadingIndicator";
import MapCard from "@/components/MapCard";
import MarkerPopup from "@/components/MarkerPopup";
import PhoneForm from "@/components/PhoneForm";
import ProjectMarkerPopup from "@/components/ProjectMarkerPopup";
import ReplyCardForm from "@/components/ReplyCardForm";
import SearchRow from "@/components/SearchRow";
import ToggleField from "@/components/ToggleField";
import Mapbox from "mapbox-gl";
import "moment/locale/nl";
import { InfoIcon, PhoneIcon, SearchIcon, UserIcon, XIcon, RefreshCwIcon } from "vue-feather-icons";
import { MglMap, MglMarker, MglNavigationControl, MglPopup } from "vue-mapbox";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import DateField from "@/components/DateField";
import TSMapMarker from "@/components/TSMapMarker";
import SupportTicketDetailModal from "@/components/SupportTicketDetail/Modal";

export default {
	components: {
		QualityFilter,
		SearchSection,
		MapHeader,
		ExecutionAppointmentFilter,
		MarketingFilter,
		AppointmentsFilter,
		ExecutionFilter,
		PlanningFilter,
		SupportFilter,
		TSMapMarker,
		DateField,
		ProjectMarkerPopup,
		EmailForm,
		KmkForm,
		PureEnergieForm,
		ReplyCardForm,
		PhoneForm,
		MglMap,
		MglMarker,
		MglPopup,
		MarkerPopup,
		Button,
		DropdownButton,
		MglNavigationControl,
		LoadingIndicator,
		MapCard,
		CardStack,
		ToggleField,
		SearchIcon,
		XIcon,
		PhoneIcon,
		InfoIcon,
		UserIcon,
		RefreshCwIcon,
		SearchRow,
		SupportTicketDetailModal
	},

	data() {
		return {
			accessToken: "pk.eyJ1IjoidGhlcm1vIiwiYSI6ImNqeHE5MTZjNzAwdDYzbW1nY3JoMzc2NzYifQ.3McmzWYNy_Nb3Y9u-tVo7Q",
			mapStyle: "mapbox://styles/mapbox/streets-v11",
			center: [5.2793703, 52.2129919],
			zoom: 7,
			periodical: null,
			openPopup: 0,
			showSearchPopup: false,
			showAddRelationModal: false,
			showListViewPopup: false,
			selectedListItem: {},
			formType: "antwoordkaart",
			isSyncing: false,
			searchValue: "",
			lastFilter: null,
			lastFilterType: null,
			appointmentType: null
		};
	},

	created() {
		this.mapbox = Mapbox;
	},

	mounted() {

		this.fetchTrackings();
		this.fetchAgents();

		this.periodical = setInterval(() => {
			this.getMapData();
			this.fetchTrackings();
		}, 60000);

		this.$events.on("map/closePopup", () => {
			this.openPopup = 0;
		});
	},

	destroyed() {
		clearTimeout(this.periodical);
	},

	computed: {
		...mapState({
			isLoading: "loading"
		}),

		...mapState("map", {
			markers: "markers",
			trackings: "trackings",
			mapType: "mapType"
		}),
		...mapState("projects", {
			project_markers: "project_markers"
		}),
		...mapState("support_tickets", {
			support_ticket_markers: "support_tickets"
		}),
		...mapState('data', {
			agents: 'agents',
		}),
		...mapGetters({
			allowedTo: "auth/allowedTo"
		}),

		showDisplayOptions() {
			if (["support", "uitvoering", "marketing", "quality", "appointments", "execution-appointments"].includes(this.mapType)) {
				this.closeListView();
				return false;
			}

			return true;
		}
	},

	methods: {
		...mapActions({
			fetchMapMarkers: "map/fetchMapMarkers",
			fetchAppointmentMarkers: "map/fetchAppointmentMarkers",
			fetchProjectMapMarkers: "projects/fetchProjectMapMarkers",
			fetchSupportMapMarkers: "support_tickets/fetchSupportMapMarkers",
			fetchTrackings: "map/fetchTrackings",
			fetchAgents: 'data/fetchAgents',
			searchCompanies: "map/searchCompanies",
			getAllCompaniesWithoutGeo: 'admin/getAllCompaniesWithoutGeo',
			changeCompanyGeo: 'admin/changeCompanyGeo',
		}),

		...mapMutations({
			setViewingUserId: "map/setViewingUserId",
			setMapType: "map/setMapType"
		}),

		closePopup(currentPopup) {
			if (this.openPopup === currentPopup) {
				this.openPopup = 0;
			}
		},

		onMapLoaded(event) {
			this.map = event.map;
		},

		onPopupOpen(event) {
			const rect = event.popup._container.getBoundingClientRect();

			let left = 0;
			let top = 0;
			if (rect.left < 0) left = rect.left - 10;
			if (rect.top - 70 < 0) top = rect.top - 60;
			if (rect.right - window.innerWidth > 0) left = rect.right - window.innerWidth + 10;

			if (left || top) {
				this.map.panBy([left, top]);
			}
		},

		getMapData() {
			switch (this.mapType) {
				case "uitvoering":
				case "execution-appointments":
					this.getMapDataForProjectMarker(this.lastFilter);
					break;
				case "support":
					this.getMapDataForSupportMarker(this.lastFilter);
					break;
				case "appointments":
					this.getMapDataForAppointmentMarker(this.lastFilter);
					break;
				default:
					this.getMapDataForDefaultMarker(this.lastFilter);
					break;
			}
		},

		getMapDataForProjectMarker(filter) {
			this.lastFilter = filter;
			this.lastFilterType = filter.filter;
			this.appointmentType = filter.appointmentType;
			this.fetchProjectMapMarkers(Object.assign({}, filter, {search: this.searchValue}));
		},

		getMapDataForDefaultMarker(filter) {
			this.lastFilter = filter;
			this.lastFilterType = filter.filter;
			if(this.lastFilterType === 'geen_locatie') {
				this.showSearchPopup = true;
			}
			this.fetchMapMarkers(Object.assign({}, filter, {search: this.searchValue}));
		},

		getMapDataForAppointmentMarker(filter) {
			this.lastFilter = filter;
			this.lastFilterType = filter.filter;
			this.fetchAppointmentMarkers(Object.assign({}, filter, {search: this.searchValue}));
		},

		getMapDataForSupportMarker(filter) {
			this.lastFilter = filter;
			this.lastFilterType = filter.filter;
			this.fetchSupportMapMarkers(Object.assign({}, filter, {search: this.searchValue}));
		},

		openListView() {
			this.showSearchPopup = true;
		},

		closeListView() {
			this.showSearchPopup = false;
			if (this.lastFilterType === "geen_locatie") {
				this.lastFilterType = 'default';
			}
		},

		openListViewPopup(item) {
			this.selectedListItem = item;
			this.openPopup = item.id;
			this.showListViewPopup = true;

		},

		openAddRelationModal() {
			this.showAddRelationModal = true;
		},

		closeAddRelationModal() {
			this.showAddRelationModal = false;
		},

		switchForm(form) {
			this.formType = form;
		},

		search(value) {
			this.searchValue = value
			this.getMapData();
		},

		formatSqMeter(amount) {
			if (amount == null) {
				return "-"
			}
			return amount.split('.')[0].substring(0,3);
		},

		onClickSupport(marker) {
			this.$modal.show(SupportTicketDetailModal, {
				marker: marker,
				currentFilter: this.lastFilterType
			}, {
				classes: "modal support-modal",
				adaptive: true,
				scrollable: true,
				width: "100%",
				height: "auto",
				maxWidth: 1200
			});
		}
	}
};
</script>
<style lang="scss">
	button.syncing svg{
		animation: rotation 2s infinite ease-in-out;
	}

	@keyframes rotation {
		from {transform: rotate(0deg);}
		to   {transform: rotate(359deg);}
	}
</style>
